import { common } from '@mui/material/colors'
import { Avatar, Tooltip, tooltipClasses } from '@mui/material'
import { useState } from 'react'
import WarningIcon from '@mui/icons-material/Warning'

export function ToolTip (props: { text: string, icon?: JSX.Element, variant?: 'info' | 'warning' }): JSX.Element {
  const color = '#4591bb'
  const [open, setOpen] = useState(false)

  const handleTooltipClose = (): void => {
    setOpen(false)
  }

  const handleTooltipOpen = (): void => {
    setOpen(true)
  }

  return <Tooltip
    title={props.text}
    placement='top'
    onClose={handleTooltipClose}
    open={open}
    arrow
    PopperProps={{
      sx: {
        [`& .${tooltipClasses.arrow}`]: {
          color
        },
        [`& .${tooltipClasses.tooltip}`]: {
          backgroundColor: color
        }
      }
    }}
  >
    <div>
      {props.variant === 'warning' && (
        <WarningIcon onClick={handleTooltipOpen} sx={{ cursor: 'pointer' }} />
      )}
      {props.variant !== 'warning' && (
        <Avatar onClick={handleTooltipOpen} sx={{ bgcolor: common.black, width: '18px', height: '18px', fontSize: '15px', cursor: 'pointer' }}>i</Avatar>
      )}
    </div>
  </Tooltip>
}
